import { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { Row, Col, Tab, Nav } from "react-bootstrap";

const tabs = [
    {
        company: 'Chaopraya Mahanakorn PCL.',
        role: 'Web Designer',
        period: 'Oct, 2019 - Present',
        dec: 'Developed responsive and scalable web pages using React.js and Next.js for high-performance applications. Collaborated with cross-functional teams to implement web accessibility best practices and optimize user experience. Designed UI/UX in Figma to ensure seamless integration with development.',
        content: [
            {
                title: 'Designed and Developed Responsive Web Pages using React.js and Next.js ',
                dec: 'Designed and developed responsive web pages using React.js and Next.js to create scalable, high-performance applications, ensuring smooth user experiences across all devices by implementing modern frontend technologies.',
            },
            {
                title: 'Designed Flex Message for Weekly Sales Report',
                dec: 'Designed and developed a Flex Message for the weekly sales report of each team, gathering requirements from the marketing team and creating an interface that is user-friendly, functional, and aligned with user needs.',
            },
            {
                title: 'Condominium Booking System',
                dec: 'Designed and developed a Condominium Booking System, incorporating responsive UI/UX design, ensuring easy navigation and efficient booking process for users, with seamless integration of backend data.'
            },
            {
                title: 'Lead Notification System',
                dec: 'Developed a Lead Notification System using API through Line Notify and Microsoft Teams to allow the marketing and sales teams to quickly receive and track leads, enabling immediate follow-up and improved communication.'
            },
        ],
    },
    {
        company: 'BEAUTIPLEX COMPANY LIMITED. ',
        role: 'Webmaster & Digital marketing ',
        period: 'Dec, 2017 - Sep, 2019',
        dec: 'Support online marketing by managing various marketing channels, analyzing target audiences, optimizing strategies, tracking social media trends, creating content, managing WordPress websites, and collaborating with the marketing team to develop new content.',
        content: [
            {
                title: 'Marketing Channel Operations',
                dec: 'Support the day-to-day operotions of the marketing channels in order to drive traffic to website.',
            },
            {
                title: 'Audience Research & Analysis',
                dec: 'Conduct on-going research/ analysis into target audience to ensure morketing ond ttraction strategies are relevant.',
            },
            {
                title: 'Social Media Content Strategy',
                dec: 'Focus on social media trends to creation social topic and orgonize social media calendar.',
            },
            {
                title: 'Web Design & Development (WordPress)',
                dec: 'Responsible for the design and development of web pages for Wordpress.',
            },
        ],
    },
    {
        company: 'GTE Digital Co., Ltd.',
        role: 'Web Designer ',
        period: 'Feb, 2017 - Nov, 2017 ',
        dec: 'Responsible for designing and developing user-friendly websites using HTML, CSS, and WordPress. Maintained websites, performed plugin updates, and implemented responsive web design to ensure compatibility across devices.',
        content: [
            {
                title: '',
                dec: 'Creat website layout/user interface by using stondard HTML, CSS for Wordpress.',
            },
            {
                title: '',
                dec: 'Maintaining web site and updating plugin.',
            },
            {
                title: '',
                dec: 'Develop web site using responsive web design for desktop and mobile use.',
            },

        ],
    },
];

const ExperienceTabs = () => {
  const [activeKey, setActiveKey] = useState(tabs[0]?.company || ""); // Default active key
  const handlers = useSwipeable({
    onSwipedLeft: () => setActiveKey(tabs[(tabs.indexOf(activeKey) + 1) % tabs.length]?.company),
    onSwipedRight: () => setActiveKey(tabs[(tabs.indexOf(activeKey) - 1 + tabs.length) % tabs.length]?.company),
    trackMouse: true,
  });

  return (
    <Row id="experience" className="mb-20 justify-content-center min-vh-100">
      <Col xxl={10} xl={10} lg={12} md={12} sm={12}>
        <h3 className="uppercase text-title text-white px-4">
          <span className="text-main">02. </span>Places I've Contributed
        </h3>
        <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
          <Row className="text-white p-4">
            {/* Left Navigation - For larger screens */}
            <Col xxl={4} xl={4} lg={4} md={5} sm={5} className="mb-5">
              <Nav variant="pills" className="flex-column">
                {tabs.map((tab, index) => (
                  <Nav.Item key={index}>
                    <Nav.Link eventKey={tab.company}>{tab.period}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>

            {/* Right Content Area */}
            <Col xxl={8} xl={8} lg={8} md={7} sm={7}>
              <Tab.Content {...handlers}>
                {tabs.map((tab, index) => (
                  <Tab.Pane eventKey={tab.company} key={index}>
                    <h5 className="font-m">
                      {tab.role} <span className="font-m text-main">@ {tab.company}</span>
                    </h5>
                    <p className="text-jobs ">{tab.dec}</p>
                    <ul className="mt-3">
                      {tab.content.map((item, idx) => (
                        <li key={idx} className="mb-3">
                          {item.title && <h6 className="fw-bold text-white font-m">{item.title}</h6>}
                          <p className="text-jobs">{item.dec}</p>
                        </li>
                      ))}
                    </ul>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Col>
    </Row>
  );
};

export default ExperienceTabs;
